<template>
    <div>
      <div class="form-control">
            <input 
              v-model="email" 
              data-testid="email-input"
              data-qa="forgotPassword_emailInput"
              type="email" 
              name="email" 
              :placeholder="$t('email')"
              value v-on="$listeners" 
              @blur="$v.email.$touch()"
              :class="{ 'error-boarder': $v.email.$error }" >
            <i class="fas fa-envelope"></i>
          </div>
          <template v-if="$v.email.$error">
            <div v-if="!$v.email.email" class="errorMessage">{{ $t('emailValid') }}</div>
            <div v-if="!$v.email.required" class="errorMessage">{{ $t('emailReq') }}</div>
          </template>
          <p>
            <button
              class="login-btn"
              data-qa="sendEmailButton"
              sytle="text-transform: uppercase;"
              :disabled="$v.email.$invalid"
              @click="forgetPassword"
            >
              {{ $t('sendMail') }}
            </button>
          </p>
    </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';

export default {
  components: {
  },
  data() {
    return {
      email: ''
    }
  },
  validations: {
    email: {
      required,
      email,
    }
  },
  methods: {
    forgetPassword() {
      this.$store
        .dispatch('forgotPassword', {
          email: this.email
        })
        .then(() => {
          this.$emit('success-mail', {})
        })
        .catch((err) => {
          // console.log('Show error notification!')
          this.error = err.data.message
        })
    }
  }
}
</script>

<style lang="css" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  text-decoration: none;
}

.login-btn {
  color: var(--primary) !important;
  border: 1px solid var(--primary);
  background: none;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  padding: 10px 20px;
  border-radius: 5px;
  transition: 0.3s;
  transition-property: background;
}

.login-btn:hover {
  background: var(--primary);
  color: var(--bright) !important;
}

.logo-img path {
  fill: var(--primary);
}
.wrapper {
    min-height: 100vh;
    display: grid;
    grid-template-columns: 60% 1fr;
    color: #696969;
}

.error-boarder {
  border: 2px solid var(--primaryDark);
}

.eyeIcon {
  position: absolute;
    top: 20px;
    right: 20px;
}

.signInLogo {
  width: 40%;
  margin-bottom: 2em;
}
.cls-1 {
  fill: var(--primary);
}

.shadow {
  -webkit-filter: drop-shadow(3px 4px 4px rgba(0, 0, 0, 0.29));
  filter: drop-shadow(3px 4px 4px rgba(0, 0, 0, 0.29));
  /* Similar syntax to box-shadow */
  }
section {
    display        : flex;
    flex-direction : column;
    justify-content: center;
    align-items    : center;
    padding        : 48px;
}
.error {
  background-color:none !important;
  border-color: none !important;
}
.errorMessage {
  margin-bottom: 0.2em;
  color: var(--primaryDark);
}
.forgotPass {
  color: var(--primaryDark) !important;
  background-color: none !important;
  text-decoration-line: none;
}

.close {
  position: absolute;
  left: 15px;
  top: 15px;
  width: 32px;
  height: 32px;
  opacity: 0.3;
}
.close:hover {
  opacity: 1;
}
.close:before, .close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 33px;
  width: 2px;
  background-color: #333;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}


.side {
  	background: linear-gradient(16deg, rgba(76,158,134,1) 0%, rgba(61,113,109,1) 8%, rgba(47,71,85,1) 38%, rgba(44,62,80,1) 47%, rgba(44,62,80,1) 50%, rgba(44,62,80,1) 80%);  /* background: url("../assets/static/images/background.png")no-repeat; */
	height: 100%;
}

.side img {
    width    : 30%;
}

.side p {
    max-width     : 500px;
    color         : #ddfdff;
    letter-spacing: 1px;
    line-height   : 1.8em;
    margin-bottom : 40px;
}

.side .main-msg {
    color        : rgb(96, 204, 172);
    font-size    : 3.2em;
    font-weight  : bold;
    line-height  : 1.5em;
    margin-bottom: 20px;
}

.title {
    font-size     : 3em !important;
    font-weight   : bold;
    text-align    : center;
    letter-spacing: 1px;
    color: var(--bg);
}

.divider {
  color: var(--bg);
	width: 100%;
	text-align:center;
}

.divider hr {
	margin-left:auto;
	margin-right:auto;
	width:40%;

}

.left {
	float:left;
}

.right {
	float:right;
}

.welcome-message {
    text-align   : center;
    font-size    : 1.1em;
    line-height  : 28px;
    margin-bottom: 10px;
}

form {
    width         : 100%;
    max-width: 400px;
    display       : flex;
    flex-direction: column;
}

.form-control {
    width        : 100%;
    position     : relative;
    margin-bottom: 24px;
    border: none !important;
}

input,
button {
    border       : none;
    outline      : none;
    border-radius: 30px;
    font-size    : 1.1em;
}

input {
    width         : 100%;
    background    : #e6e6e6;
    color         : #333;
    letter-spacing: 0.5px;
    padding       : 14px 64px;
}

input~i {
    position  : absolute;
    left      : 22px;
    top       : 80%;
    transform : translateY(-50%);
    color     : var(--gray);
    transition: color 0.4s;
    font-size: 1.3em;
}

input:focus~i {
    color: #0E484B;
}

button.action {
    color           : #fff;
    padding         : 14px 64px;
    margin          : 32px auto;
    text-transform  : uppercase;
    letter-spacing  : 2px;
    font-weight     : bold;
    background-color: var(--primary);
    background: var(--primary);
    cursor          : pointer;
    transition      : opacity 0.4s;
}

button.action:hover {
    opacity: 0.9;
}

button:disabled,
button[disabled]{
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}

.login {
    position       : absolute;
    bottom         : 32px;
    display        : flex;
    justify-content: center;
    align-items    : center;
}

.login button {
    margin-left  : 16px;
    background   : none;
    color: var(--bg);
    border-bottom: 2px solid var(--bg);
    border-radius: 0;
    padding      : 4px;
    cursor       : pointer;
    font-weight  : bold;
}

.login button:hover {
    color: var(--primary);
    border-bottom: 2px solid var(--primary);
}


.login p {
  margin-bottom: 0;
}

/* ----  Responsiveness   ----  */
@media (max-width: 480px) {
.section {
  padding: 48px 20px 60px 20px !important;;
}
.login {
  bottom: 5px;
}
}

@media (max-width: 780px) {
    .wrapper {
        grid-template-columns: 1fr;
    }

    .side {
        display: none;
    }
    .section {
      padding-bottom: 0;
    padding-top: 0;
    }
}

@media (min-width: 775px) {
.close {
  display: none;
}
}
</style>